export default function visibleInBody(rect) {
    const bodyRect = document.body.getBoundingClientRect();

    return (
        rect.top >= bodyRect.top &&
        rect.bottom <= window.innerHeight &&
        rect.left >= bodyRect.left &&
        rect.right <= bodyRect.right
    );
}
